import React from "react";
import { Clock, LogOut, RefreshCw } from "lucide-react";
import Logo from "../assets/chargingadda-logo.png";
import { signOut } from "../utils/logout";
import "./Login/LoginPage.scss";

/**
 * Shown instead of the dashboard to someone who is signed in but has no
 * roles yet -- i.e. they came in through their company's single sign-on
 * without an invite. An admin approves them under Settings -> Members.
 *
 * Roles live in the access token, so after approval a fresh sign-in is
 * needed; "Check again" simply re-runs the (SSO) login.
 */
const PendingApproval: React.FC = () => {
  let name = "";
  let email = "";
  try {
    const u = JSON.parse(localStorage.getItem("user_info") || "{}");
    name = u.name || u.given_name || "";
    email = u.email || u.preferred_username || "";
  } catch {
    /* ignore */
  }

  const checkAgain = () => {
    // Drop the role-less tokens and start a new sign-in (SSO makes this one click).
    ["access_token", "id_token", "user_info", "login_time"].forEach((k) => localStorage.removeItem(k));
    window.location.href = "/login";
  };

  return (
    <div className="lgn-page">
      <div className="lgn-card">
        <img className="lgn-brand" src={Logo} alt="ChargingAdda" />
        <div className="lgn-user">
          <div className="avatar"><Clock size={16} /></div>
          <div className="who">
            <strong>{name || "Access requested"}</strong>
            <span>{email}</span>
          </div>
        </div>
        <h1 className="lgn-title">Waiting for approval</h1>
        <p className="lgn-sub">
          You signed in with your company account, but an administrator of this admin dashboard has
          not given you access yet. They can approve your request under Settings → Members.
          You will be able to use the dashboard as soon as that happens.
        </p>
        <div style={{ display: "flex", flexDirection: "column", gap: 10 }}>
          <button className="lgn-btn lgn-btn--primary" onClick={checkAgain}>
            <RefreshCw size={16} /> Check again
          </button>
          <button className="lgn-btn" onClick={signOut}>
            <LogOut size={16} /> Sign out
          </button>
        </div>
        <div className="lgn-foot">Secured by ChargingAdda</div>
      </div>
    </div>
  );
};

export default PendingApproval;
